import React, { useContext, useCallback } from 'react';
import { Button } from 'ui-components/components/button';
import PropTypes from 'prop-types';
import PresetGroupModal from '../preset-group-modal';
import { PresetGroupsContext } from '../context';
import { editPresetGroupButton } from '../formattedMessageConstants';

export const EditButton = ({ presetGroupId }) => {
  const { isModalOpen, setIsModalOpen, selectedPresetId, setSelectedPresetId } = useContext(PresetGroupsContext);
  const openModal = useCallback(() => {
    setIsModalOpen(true);
    setSelectedPresetId(presetGroupId);
  }, [presetGroupId, setIsModalOpen, setSelectedPresetId]);
  const onClose = useCallback(() => {
    setIsModalOpen(false);
  }, [setIsModalOpen]);
  return (
    <>
      <Button onClick={openModal} theme='link'>
        {editPresetGroupButton}
      </Button>
      {isModalOpen && selectedPresetId === presetGroupId && <PresetGroupModal onClose={onClose} presetGroupId={presetGroupId} />}
    </>
  );
};

EditButton.propTypes = {
  presetGroupId: PropTypes.string.isRequired,
};
